<template>
  <div>
    <v-btn
      @click="addBookmark(id, isFavourite)"
      text
      rounded
      color="amber lighten-2"
    >
      <v-icon v-if="!isFavourite">
        mdi-bookmark-outline
      </v-icon>
      <v-icon v-else>
        mdi-bookmark
      </v-icon>
    </v-btn>
    <v-snackbar v-model="favouriteStatus" top color="success">
      <v-icon color="white">mdi-check-circle-outline</v-icon>
      &nbsp;{{ favouriteText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          @click="favouriteStatus = false"
          color="red"
          x-small
          text
        >
          <v-icon dark>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Api from "@/api/api";
import { mapState, mapMutations } from "vuex";

export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    isFavouriteIncome: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      favouriteText: "",
      favouriteStatus: false,
      isFavourite: this.isFavouriteIncome
    };
  },
  computed: {
    ...mapState({
      User: (state) => state.account.User,
      ConfApp: (state) => state.conf.ConfApp,
      HttpOptions: (state) => state.conf.http_options
    })
  },
  methods: {
    ...mapMutations({
      update_login_dialog: "conf/update_login_dialog"
    }),
    async addBookmark(id, isFavourite) {
      if (this.User.isLogged && this.User.is_subscribed_to_justclick) {
        const data = { post_id: id };
        try {
          if (isFavourite) {
            const result = await Api.removePostFromFavourites(
              data,
              this.HttpOptions
            );
            if (result.success) {
              this.isFavourite = false;
              this.favouriteText = "Пост удален из избранного.";
              this.favouriteStatus = true;
            }
          } else {
            const result = await Api.addPostToFavourites(
              data,
              this.HttpOptions
            );
            if (result.success) {
              this.isFavourite = true;
              this.favouriteText = "Пост добавлен и в избранное.";
              this.favouriteStatus = true;
            }
          }
        } catch (e) {
          this.$store.dispatch("errorHandler", e);
        }
      } else {
        this.update_login_dialog(true);
      }
    }
  }
};
</script>
